import { bool, object } from "prop-types";
import { observer } from "mobx-react";
import { BreakdownColumns } from "@repo/utils";
import {
  PinnableCell,
  useEstimateEditorSettings,
  useEstimateEditorStore,
  useEstimateTableSettings,
  usePresetFieldNames, useVisibilityModeCellClassName,
  VisibilityButton
} from "@tools";
import { Grid } from "@material-ui/core";
import { LastPinnedCellActions } from "../components/LastPinnedCellActions";
import classnames from "classnames";
import { useResizeObserver } from "@hooks";
import { useMemo } from "react";
import useCellStyle from "@tools/EstimateEditor/styles/CommonTableCellStyles.style";

export const TaskLabelsCell = observer(({
  columnSettings,
  section,
  isLastPinnedCell,
  isLastPinnableCell,
}) => {
  const { allowEdition, isProposal, isLibrary } = useEstimateEditorSettings();
  const { setArtificialLabelColumnWidth, showActionsOnScroll } = useEstimateTableSettings();
  const { visibilityMode } = useEstimateEditorStore();
  const { getFieldName } = usePresetFieldNames(isProposal);
  const cellClasses = useCellStyle();
  
  const ref = useResizeObserver((el) => setArtificialLabelColumnWidth(el.clientWidth));
  
  // const { hideLabels } = section;
  const { hide, pinLeftPx } = columnSettings;
  
  const className = useVisibilityModeCellClassName(hide);
  
  const showActions = useMemo(() => (
    showActionsOnScroll ? isLastPinnedCell : isLastPinnableCell
  ), [ isLastPinnedCell, isLastPinnableCell, showActionsOnScroll ]);
  
  return <>
    <PinnableCell
      ref={ref}
      resizeable
      isHeader
      colName={ BreakdownColumns.LABELS }
      
      allowOverflowDisplay={isLastPinnedCell}
      pinnedLeft={typeof pinLeftPx === "number"}
      actions={ showActions && <LastPinnedCellActions section={section} /> }
      allowEdition={ allowEdition && !isLibrary }
      columnSettings={ columnSettings }
      innerClassName="items-end"
    >
      <Grid
        item container
        alignItems="center"
        className={classnames("w-max", cellClasses.sizeXSmall, className)}
      >
        <span className="preset-tableBreakdownHeader pt-labels ml-0-5 text-left">
          { getFieldName("pt-labels") }
        </span>
        {
          visibilityMode &&
          <VisibilityButton
            size="tiny"
            hidden={hide}
            onChange={columnSettings.setHide}
          />
        }
      </Grid>
    </PinnableCell>
  </>
});

TaskLabelsCell.propTypes = {
  section: object.isRequired,
  columnSettings: object.isRequired,
  isLastPinnedCell: bool,
  isLastPinnableCell: bool,
}